export default __webpack_public_path__ + "static/media/addButton.98ec5b8d.svg";